import axiosAPI from 'axios';

const axios = axiosAPI.create({
    baseURL: process.env.REACT_APP_API_URL
})

axios.interceptors.request.use(request => {
    return request
})

axios.interceptors.response.use(function (response) {
    return response;
}, function (error) {    
    return Promise.reject(error);
});



export { axios };